module.exports = __webpack_public_path__ + "img/dne-coin.238b8cc3.png";